import React from 'react';


const PlayButtonFill = () => (
  <svg width="40" height="40" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_b_2762_2807)">
      <g filter="url(#filter1_b_2762_2807)">
        <path d="M24.0001 43.3606C34.6924 43.3606 43.3601 34.6929 43.3601 24.0006C43.3601 13.3084 34.6924 4.64062 24.0001 4.64062C13.3079 4.64062 4.64014 13.3084 4.64014 24.0006C4.64014 34.6929 13.3079 43.3606 24.0001 43.3606Z" fill="#111314" fillOpacity="0.64" />
        <path d="M42.8601 24.0006C42.8601 34.4167 34.4162 42.8606 24.0001 42.8606C13.584 42.8606 5.14014 34.4167 5.14014 24.0006C5.14014 13.5845 13.584 5.14062 24.0001 5.14062C34.4162 5.14062 42.8601 13.5845 42.8601 24.0006Z" stroke="white" />
      </g>
      <path d="M32.12 23.2397L21.14 16.1797C21.004 16.0939 20.8474 16.0462 20.6866 16.0414C20.5258 16.0367 20.3667 16.0751 20.2258 16.1527C20.085 16.2303 19.9674 16.3442 19.8855 16.4826C19.8036 16.621 19.7602 16.7789 19.76 16.9397V31.0597C19.7602 31.2205 19.8036 31.3784 19.8855 31.5168C19.9674 31.6552 20.085 31.7691 20.2258 31.8467C20.3667 31.9243 20.5258 31.9628 20.6866 31.958C20.8474 31.9532 21.004 31.9055 21.14 31.8197L32.12 24.7597C32.2481 24.6785 32.3535 24.5662 32.4266 24.4334C32.4996 24.3005 32.5379 24.1513 32.5379 23.9997C32.5379 23.8481 32.4996 23.6989 32.4266 23.566C32.3535 23.4332 32.2481 23.3209 32.12 23.2397Z" fill="white" />
    </g>
    <defs>
      <filter id="filter0_b_2762_2807" x="-5" y="-5" width="58" height="58" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="2.5" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2762_2807" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2762_2807" result="shape" />
      </filter>
      <filter id="filter1_b_2762_2807" x="-3.35986" y="-3.35938" width="54.72" height="54.7207" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation="4" />
        <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_2762_2807" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_2762_2807" result="shape" />
      </filter>
    </defs>
  </svg>

);

export default PlayButtonFill;
